import { render, staticRenderFns } from "./deleteParkingSpace.vue?vue&type=template&id=265c47c1"
import script from "./deleteParkingSpace.vue?vue&type=script&lang=js"
export * from "./deleteParkingSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports